import { Box, useTheme, Typography, useMediaQuery, Tooltip } from "@mui/material";
import React from "react";
import { tokens } from "../../Theme/theme";
import { Header } from "../global/Header";
import Statbox from "./../Dashborad/Statbox";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import BarChart from "../Charts/BarChart";
import PieChart from "../Charts/PieChart";
import { useEffect } from "react";
import { useState } from "react";
import LineChart from "../Charts/LineChart";
import { json, Link, useLocation, useNavigate } from "react-router-dom";
import BASE_URL from "../../NetworkConfig/ApiConfig";
import { format, utcToZonedTime } from "date-fns-tz";
import { CircleLoader, BounceLoader } from 'react-spinners'
import CustomCarousel from "../Utils/CustomSlider";
import MultiPartFormPopup from "../Utils/MultiPartFormPopup";
import SpaceNoticeboardAdd from "../Utils/SpaceNoticeboardAdd";
import SpaceNoticeboardReplacePopup from "../Utils/SpaceNoticeboardReplacePopup";
import PopupDeleteConfirmation from "../Utils/SpaceNBDeleteConfirmation";
import RemoveCMFromSpace from "../Utils/RemoveCMFromSpace";
import { EditAttributesRounded, EditOutlined, RemoveCircleOutline, RemoveRedEye } from "@mui/icons-material";
import AddCommunityPopup from "../Utils/AddCommunityPopup";
import searchIcon from '../../assets/search.svg'
import EditSpaceDetailsPopup from "../Utils/EditSpaceDetailsPopup";


function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}




const SpaceDetail = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [pageData, setPageData] = useState({});
    const [userCount, setUserCount] = useState(0);
    const [ActiveUsersCount, setActiveUsersCount] = useState(0);
    const [ActiveYesterdayCount, setActiveYesterdayCount] = useState(0)
    // const [loading, setloading] = useState(true);
    const [error, seterror] = useState("Loading....");
    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')
    const [openNoticeboardForm, setOpenNoticeBoardForm] = useState(false);
    const [openNoticeboardReplaceForm, setOpenNoticeBoardReplaceForm] = useState(false);
    const [noticeboardSlideToReplace, setNoticeboardSlideToReplace] = useState({})
    const [openDeleteNoticeboardPopup, setDeleteNoticeboardPopup] = useState(false)
    const [currentSelectedNoticeboardSlide, setCurrentSelectedNoticeboardSlide] = useState({})
    const [userProfile, setUserProfile] = useState({})
    const [selectedCommunity, setSelectedCommunity] = useState({})
    const [showCMRemovePopup, setShowCMRemovePopup] = useState(false)
    const [showCMAddPopup, setShowCMAddPopup] = useState(false)
    const [searchQuery, setSearchQuery] = useState("")
    const [searchedCommunities, setSearchedCommunities] = useState([])
    const [activeUserCount, setActiveUserCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [showSpaceEditPopup, setShowSpaceEditPopup] = useState(false)
    const query = useQuery()

    const navigate = useNavigate()



    const FetchDashboardDetails = async () => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/get-page-details/${query.get("ref")}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setPageData(data.response);
            return;
        }
        if (data.success === false) {
            alert("error")
            seterror(data.response);
            return;
        }
    };

    const calculatePercentageChange = (today, yesterday) => {
        if (yesterday === 0 && today == 0) return 0;
        if (yesterday === 0 && today > 0) return 100;
        if (today == 0) return -100;
        const percentageChange = ((today - yesterday) / yesterday) * 100;
        return percentageChange.toFixed(2); // Limit to 2 decimal places
    };


    useEffect(() => {
        async function getUserProfile() {
            const profile = localStorage.getItem("profile");
            setUserProfile(JSON.parse(profile))
        }
        getUserProfile()
        FetchDashboardDetails();
        getSpaceTodayActive(query.get("ref"))

    }, []);


    const deleteNoticeboardData = async (item) => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/community/noticeboard/delete/${item._id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();

        console.log(data)
        if (data.success === true) {
            const filteredList = pageData.noticeboard.filter(l => l._id != item._id)
            pageData.noticeboard = filteredList
            setDeleteNoticeboardPopup(false)
            setCurrentSelectedNoticeboardSlide({})
            alert("Noticeboard slide deleted")
        } else {
            alert(data.response)
        }

    };

    const removeCommunity = async (cm_id) => {
        setSelectedCommunity({})
        setShowCMRemovePopup(false)
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/removecm`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: JSON.stringify({
                space: query.get("ref"),
                community: cm_id
            })
        });
        const data = await response.json();

        console.log(data)
        if (data.success === true) {
            alert("Community has been removed")
            FetchDashboardDetails()
        } else {
            alert(data.response)
        }

    };

    const addCommunity = async (cm_id) => {
        setShowCMAddPopup(false)
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/addcm`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
            body: JSON.stringify({
                space: query.get("ref"),
                community: cm_id
            })
        });
        const data = await response.json();
        if (data.success === true) {
            alert("Community has been added")
            FetchDashboardDetails()
        } else {
            alert(data.response)
        }
    };

    const getSpaceTodayActive = async (space_id) => {

        setLoading(true)

        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/getmembersactivitydetail/${space_id}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setActiveUserCount(data.response)
        } else {
            setActiveUserCount(0)
        }
        setLoading(false)
    };


    useEffect(() => {
        if (searchQuery.length > 0) {
            const delayDebounceFn = setTimeout(() => {
                searchCommunities(searchQuery);
            }, 500); // 500ms delay

            return () => clearTimeout(delayDebounceFn);
        } else {
            setSearchedCommunities([]); // Clear results when input is empty
        }
    }, [searchQuery]);

    const searchCommunities = async (q) => {
        // setloading(true);
        const token = localStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/spaces/communities/search?q=${q}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "auth-token": token,
            },
        });
        const data = await response.json();
        if (data.success === true) {
            setSearchedCommunities(data.data)
        } else {
            alert(data.response)
        }
    };


    if (!pageData) {
        return <Box sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex', height: "50%" }}>

            <CircleLoader size={"40px"} color={"#943bff"} />


        </Box>;
    }
    return (
        <Box m="20px" sx={{
        }}>
            <Box
                display={"flex"}
                justifyContent="space-between"
                alignItems={"center"}
                flexWrap={'wrap'}
                sx={{
                    marginBottom: isMobileScreen ? "0px" : "20px", marginInline: isMobileScreen ? "0px" : "10px"
                }}
            >
                <Header
                imgInc={true}
                    title={`${pageData.space?.name ?? ""}`}
                    tag={pageData.space?.type ?? ""}
                    subtitle={"Here are some detailed report of this space."}
                />

                {
                    userProfile.Role == "ADMIN" && (
                        <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', gap: "10px", marginTop: isMobileScreen ? "10px" : "0px" ,marginBottom: (isMobileScreen || isTabScreen) ? "15px" : "0px" }}>

                            <Box
                                onClick={() => {
                                    setShowSpaceEditPopup(true)
                                }}
                                sx={{
                                    cursor: 'pointer', borderRadius: "8px", border: "1.5px solid #aaaaaa10",
                                    display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: false,
                                    paddingInline: "13px", paddingBlock: "8px", gap: "6px"
                                }}>
                                <EditOutlined style={{ color: "white", width: "13px", height: "13px" }} />
                                <Typography color={"#ffffff"}
                                    fontFamily={"poppins-reg"}
                                    fontSize={"12px"} style={{ display: 'flex' }} >Edit Details</Typography>

                            </Box>



                        </Box>
                    )
                }

            </Box>

            <Box
                display={"grid"}
                gridTemplateColumns="repeat(10,1fr)"
                gridAutoRows={"100px"}
                pb={"20px"}
                gap={(isMobileScreen || isTabScreen) ? "20px" : "20px"}
            >
                {/* ROW 1 */}
                <Box
                    gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
                    sx={{
                        borderRadius: "20px",
                        border: "1.7px solid transparent",
                        background:
                            "linear-gradient(#ffffff00 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, rgba(214, 152, 36, 1)) border-box",

                    }}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="center"
                >
                    <Statbox
                        title={pageData.totalUsers}
                        subtitle="Total Members"
                        icon={
                            <DownloadDoneIcon
                                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                            />
                        }

                        onClick={() => {
                            navigate("/admin/users")
                        }}
                        users={true}
                        report={0}
                    />
                </Box>

                <Box
                    gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
                    sx={{
                        background: "#ffffff08",
                        borderRadius: "20px",
                        border: "1.5px solid #aaaaaa05",
                    }}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="center"
                >
                    <Statbox
                        title={activeUserCount ?? 0}
                        subtitle="Active Today"
                        loading={loading}
                        icon={
                            <DownloadDoneIcon
                                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                            />
                        }

                        onClick={() => {
                            //navigate("/admin/users")
                        }}
                        users={true}
                        report={0}
                    />
                </Box>
                <Box
                    sx={{
                        background: "#ffffff08",
                        borderRadius: "20px",
                        border: "1.5px solid #aaaaaa05",
                    }}
                    gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
                    backgroundColor={colors.primary[400]}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="center"
                >
                    <Statbox
                        // todayonboardusers
                        title={pageData.space?.communities.length ?? 0}
                        subtitle="Communities"
                        onClick={() => {

                        }}
                        icon={
                            <DownloadIcon
                                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                            />
                        }

                        users={true}
                    />
                </Box>
                <Box
                    sx={{
                        background: "#ffffff08",
                        borderRadius: "20px",
                        border: "1.5px solid #aaaaaa05",
                    }}
                    gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
                    backgroundColor={colors.primary[400]}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="center"
                >
                    <Statbox
                        title={pageData.space?.admins.length ?? 0}
                        subtitle="Space admins"
                        onClick={() => {
                            navigate("/admin/activeusers")
                        }}
                        icon={
                            <PersonPinIcon
                                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                            />
                        }
                        users={true}

                    />
                </Box>
                <Box
                    sx={{
                        background: "#ffffff08",
                        borderRadius: "20px",
                        border: "1.5px solid #aaaaaa05",
                    }}
                    gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
                    backgroundColor={colors.primary[400]}
                    display="flex"
                    alignItems={"center"}
                    justifyContent="center"
                >
                    <Statbox
                        title={((pageData.posts ?? 0) + (pageData.crisps ?? 0) + (pageData.gossips ?? 0))}
                        subtitle="Total Content"
                        icon={
                            <StorefrontIcon
                                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                            />
                        }
                        report={((pageData.todayPosts ?? 0) + (pageData.todayCrisps ?? 0) + (pageData.todayGossips ?? 0)) != 0 ? `+${((pageData.todayPosts ?? 0) + (pageData.todayCrisps ?? 0) + (pageData.todayGossips ?? 0))} today` : 0}
                        users={((pageData.todayPosts ?? 0) + (pageData.todayCrisps ?? 0) + (pageData.todayGossips ?? 0)) == 0 ? false : true}
                    />
                </Box>

                {/* ROW 2 */}




            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', alignSelf: 'stretch', flexWrap: 'wrap', gap: (isMobileScreen || isTabScreen) ? "20px" : "20px" }}>
                <Box

                    sx={{
                        background: "#ffffff08",
                        borderRadius: "20px",
                        border: "1.5px solid #aaaaaa05",
                        overflow: 'hidden',
                        display: 'flex',
                        width: (isMobileScreen || isTabScreen) ? "100%" : "51%",
                        flexDirection: 'column'
                    }}
                >

                    <Box sx={{ display: 'flex', flexDirection: 'row', background: "#aaaaaa10", paddingLeft: "18px", paddingRight: "15px", paddingBlock: "20px", alignItems: 'center' }}>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            fontSize={isMobileScreen ? "13px" : "15px"} style={{ maxLines: 1, textOverflow: 'ellipsis', flex: 1, display: 'flex' }} >{isMobileScreen ? "" : "Space "}Noticeboard</Typography>

                        <Typography onClick={() => {
                            navigate(`/admin/noticeboard?space=${query.get("ref")}`)
                        }}
                            sx={{
                                cursor: 'pointer'
                            }}
                            style={{
                                fontFamily: "poppins-reg", fontSize: "13px",
                                color: "#ffffff", paddingInline: "15px",
                                background: '#ffffff10', paddingBlock: "5px",
                                borderRadius: "8px", border: "1px solid #ffffff20",
                                marginRight: "10px",

                            }} >Rearrange</Typography>

                        <Typography onClick={() => {
                            setOpenNoticeBoardForm(true)
                        }}
                            sx={{
                                cursor: 'pointer'
                            }}
                            style={{
                                fontFamily: "poppins-reg", fontSize: "13px",
                                color: "#ffffff", paddingInline: "12px",
                                background: '#ffffff10', paddingBlock: "5px",
                                borderRadius: "8px", border: "1px solid #ffffff20",
                                marginRight: "2px",

                            }} >Add New</Typography>
                    </Box>


                    {
                        pageData.noticeboard?.length > 0 ? (
                            <Box
                                sx={{
                                    flex: 1,                 // take remaining height
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <Box sx={{
                                    height: "100%",        // height drives size
                                    aspectRatio: 16 / 9,
                                    maxWidth: "100%",
                                }}>
                                    <CustomCarousel
                                        marginTop="0px"
                                        borderRadius="0px"
                                        borderWidth="0px"
                                        data={pageData.noticeboard}
                                        onReplace={(item) => {
                                            setNoticeboardSlideToReplace(item)
                                            setOpenNoticeBoardReplaceForm(true)
                                        }}
                                        onDelete={(item) => {
                                            setCurrentSelectedNoticeboardSlide(item)
                                            setDeleteNoticeboardPopup(true)
                                        }} >
                                        {
                                            pageData.noticeboard.map((item, index) => {
                                                return <Box sx={{ display: 'flex', }}>
                                                    <img alt={'noticeboard_banner'} src={item.mediaUrl} />


                                                    <Box sx={{
                                                        display: 'flex', position: 'absolute', background: '#ffffff', borderRadius: 100,
                                                        paddingInline: "10px", paddingBlock: "2px", margin: "10px", alignItems: 'center', justifyContent: 'center',
                                                        alignContent: 'center', justifyItems: 'center'
                                                    }}>
                                                        <Typography style={{ color: "#303030", fontFamily: "poppins-mid", fontSize: "12px" }}>{item.position}</Typography>
                                                    </Box>


                                                </Box>
                                            })
                                        }

                                    </CustomCarousel>
                                </Box>
                            </Box>
                        ) : (
                            <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>

                                <Typography mb={"40px"} style={{ color: "#ffffff90", fontFamily: "poppins-reg", fontSize: "13px" }}>There is not any noticeboard data yet.</Typography>

                            </Box>
                        )
                    }


                </Box>


                <Box

                    sx={{
                        background: "#ffffff08",
                        borderRadius: "20px",
                        border: "1.5px solid #aaaaaa05",
                        overflow: 'clip',
                        alignSelf: 'stretch',
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1
                    }}>

                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', background: "#aaaaaa10", paddingInline: "14px", paddingBlock: "22px" }}>

                        <Typography color={"#ffffff"}
                            fontFamily={"poppins-reg"}
                            fontSize={"15px"} style={{ maxLines: 1, textOverflow: 'ellipsis', flex: 1, display: 'flex' }} >Communities</Typography>

                        <Typography onClick={() => {
                            setShowCMAddPopup(true)
                        }}
                            sx={{
                                cursor: 'pointer'
                            }}
                            style={{
                                fontFamily: "poppins-reg", fontSize: "13px",
                                color: "#ffffff", paddingInline: "12px",
                                background: '#ffffff10', paddingBlock: "3px",
                                borderRadius: "8px", border: "1px solid #ffffff20",
                                marginRight: "2px",

                            }} >Add New Community</Typography>

                    </Box>

                    <Box sx={{ flexDirection: 'column', display: "flex", overflow: 'scroll', height: "450px" }} >
                        {
                            pageData.space?.communities.map((community, index) => (
                                <Box
                                    // key={`${transaction.txId}-${i}`}
                                    gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 4"}
                                    gridRow="span 2"
                                    display="flex"
                                    alignItems="center"
                                    px="15px"
                                    py={"8px"}
                                    sx={{
                                        textDecoration: 'none', paddingY: "10px", flexDirection: 'row', alignItems: 'center',
                                        display: 'flex', borderBottom: "1px solid #aaaaaa10"
                                    }}
                                >
                                    <Box
                                        component={Link}
                                        to={{
                                            pathname: "/admin/communitydetail",
                                            search: `?community=${community._id}`,
                                            state: { fromDashboard: true },
                                            // console.log(first)
                                        }}
                                        sx={{
                                            textDecoration: 'none', flex: 1, flexDirection: 'row', alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <img
                                                alt="profile-user"
                                                width="40px"
                                                height="40px"
                                                src={`${community.logo}`}
                                                style={{
                                                    cursor: "pointer", objectFit: 'cover',
                                                    borderRadius: "50%",
                                                    border: "3px solid #ffffff10"
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ ml: "20px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{community.title}</Typography>

                                            <Box sx={{
                                                display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "4px",
                                                gap: "5px"
                                            }}>
                                                <Typography color={"#ffffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        borderRadius: "4px",
                                                        background: "#ffffff20",
                                                        paddingTop: "2px",
                                                        paddingBottom: "2px",
                                                        paddingLeft: "8px",
                                                        paddingRight: "8px"
                                                    }}
                                                    fontSize={"10.5px"}>{community.communityType}</Typography>
                                            </Box>
                                        </Box>

                                    </Box>

                                    {
                                        userProfile.Role && userProfile.Role == "ADMIN" && (

                                            <Tooltip arrow title={`Remove from space`}>
                                                <Box
                                                    onClick={() => {
                                                        setSelectedCommunity(community)
                                                        setShowCMRemovePopup(true)
                                                    }}
                                                    sx={{
                                                        width: "35px",
                                                        height: "35px",
                                                        background: "#ff220010",
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        display: 'flex',
                                                        borderRadius: "100px", cursor: 'pointer'
                                                    }}>

                                                    <RemoveCircleOutline sx={{ color: "red" }} />

                                                </Box>
                                            </Tooltip>

                                        )
                                    }

                                </Box>
                            ))
                        }
                    </Box>



                </Box>
            </Box>



            <SpaceNoticeboardAdd open={openNoticeboardForm}
                onSuccess={() => {
                    setOpenNoticeBoardForm(false)
                    FetchDashboardDetails()
                }}
                onClose={() => setOpenNoticeBoardForm(false)}
                community={pageData.space?._id} communityName={pageData.space?.name ?? ""}

                creators={[{ name: "Cerkle", id: 123 }]} />


            {
                noticeboardSlideToReplace._id && (
                    <SpaceNoticeboardReplacePopup
                        open={openNoticeboardReplaceForm}
                        onClose={() => setOpenNoticeBoardReplaceForm(false)}
                        slideData={noticeboardSlideToReplace}
                    />
                )
            }

            <PopupDeleteConfirmation onDelete={(item) => {
                deleteNoticeboardData(item)
            }} data={currentSelectedNoticeboardSlide} isNoticeboard={true} open={openDeleteNoticeboardPopup} onClose={() => {
                setDeleteNoticeboardPopup(false)
                setCurrentSelectedNoticeboardSlide({})
            }} />

            <RemoveCMFromSpace open={showCMRemovePopup} onClose={() => setShowCMRemovePopup(false)} data={selectedCommunity} onDelete={() => {
                removeCommunity(selectedCommunity._id)
            }} />


            <EditSpaceDetailsPopup
                open={showSpaceEditPopup}
                data={pageData.space ?? {}}
                onClose={() => setShowSpaceEditPopup(false)}
                onComplete={() => {
                    setShowSpaceEditPopup(false)
                    FetchDashboardDetails()
                }}
            />


            <AddCommunityPopup open={showCMAddPopup} onClose={() => setShowCMAddPopup(false)} onDelete={() => {
                //removeCommunity(selectedCommunity._id)
            }} >

                <Box sx={{ flexDirection: 'column', display: 'flex' }} >
                    <Box sx={{
                        flexDirection: 'row',
                        backgroundColor: "#ffffff10",
                        display: 'flex',
                        borderRadius: "15px",
                        border: "1px solid transparent",
                        background:
                            "linear-gradient(#ffffff10 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#ffffff30, #00000000) border-box"
                    }}>
                        <img
                            alt="search_icon"
                            width="18px"
                            height="18px"
                            style={{
                                objectFit: 'contain',
                                filter: 'invert(1) hue-rotate(180deg) brightness(1)',
                                alignSelf: 'center',
                                marginLeft: "15px"
                            }}
                            src={searchIcon}
                        />
                        <input placeholder="Search community..."
                            multiple={false}
                            value={searchQuery}
                            onChange={(v) => {
                                setSearchQuery(v.target.value)
                            }}
                            style={{
                                outline: 'none',
                                backgroundColor: "#aaaaaa00",
                                borderWidth: 0,
                                paddingLeft: "15px",
                                paddingRight: "15px",
                                paddingTop: "10px",
                                flex: 1,
                                display: 'flex',
                                fontSize: "15px",
                                paddingBottom: "10px",
                                fontFamily: 'poppins-reg',
                                borderRadius: "100px",
                                color: "white"
                            }} />


                    </Box>

                    <Box sx={{ minHeight: "350px", display: 'flex', flexDirection: 'column' }}>

                        {
                            searchedCommunities.map((community, index) => (
                                <Box
                                    onClick={() => {
                                        addCommunity(community._id)
                                    }}
                                    display="flex"
                                    alignItems="center"
                                    px="15px"
                                    py={"8px"}
                                    sx={{
                                        textDecoration: 'none', paddingY: "10px", flexDirection: 'row', alignItems: 'center',
                                        display: 'flex', borderBottom: "1px solid #aaaaaa10"
                                    }}
                                >
                                    <Box

                                        sx={{
                                            textDecoration: 'none', flex: 1, flexDirection: 'row', alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <img
                                                alt="profile-user"
                                                width="40px"
                                                height="40px"
                                                src={`${community.logo}`}
                                                style={{
                                                    cursor: "pointer", objectFit: 'cover',
                                                    borderRadius: "50%",
                                                    border: "3px solid #ffffff10"
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ ml: "20px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>

                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                fontSize={"13px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{community.title}</Typography>

                                            <Box sx={{
                                                display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "4px",
                                                gap: "5px"
                                            }}>
                                                <Typography color={"#ffffffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        borderRadius: "4px",
                                                        background: "#ffffff20",
                                                        paddingTop: "2px",
                                                        paddingBottom: "2px",
                                                        paddingLeft: "8px",
                                                        paddingRight: "8px"
                                                    }}
                                                    fontSize={"10.5px"}>{community.communityType}</Typography>
                                            </Box>
                                        </Box>

                                    </Box>


                                </Box>
                            ))
                        }

                    </Box>

                </Box>



            </AddCommunityPopup>

        </Box>
    );
};

export default SpaceDetail;
